import qs from "query-string";
const queryString = (queryParse: any) =>
  qs.stringify(queryParse, {
    skipNull: true,
    skipEmptyString: true,
    arrayFormat: "index",
  });

export default queryString;
